import React, { useState } from "react";
import headerImage from "../assets/images/header-pipeline-scaled.jpg";
import sectionImage from "../assets/images/img-origen-esteroideo.png";
import softgelImage from "../assets/images/img-gelatina-blanda.png";
import "./Pipeline.css";
import { FaChevronDown } from "react-icons/fa";

const Pipeline = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="pipeline-page">

      {/* HERO SECTION */}
      <section className="pipe-hero">
        <img src={headerImage} alt="Pipeline" className="pipe-hero-img" />

        <div className="pipe-hero-overlay"></div>

        <div className="pipe-hero-content">
          <div className="pipe-left">
            <h1>
              Comprehensive <br />
              healthcare
            </h1>
          </div>

          <div className="pipe-right">
            <p>
              We offer comprehensive healthcare solutions under various
              product lines, including women’s health, hormonal and cancer
              treatments and medicines for high prevalence diseases and
              such highly specialised fields as transplants.
            </p>
          </div>
        </div>
      </section>


      {/* WOMEN HEALTH SECTION */}
      <section className="women-health-section">

        {/* LEFT IMAGE SIDE */}
        <div className="left-side">
          <img src={sectionImage} alt="Women health" />
          <div className="overlay"></div>

          <div className="left-text">
            <h1>
              Women’s health, <br />
              hormonal and cancer <br />
              treatments
            </h1>
          </div>
        </div>

        {/* RIGHT CONTENT SIDE */}
        <div className="right-side">

  {/* Intro Paragraph */}
  <p className="section-intro">
    We have a plant specialised in the development and manufacturing of 
    <strong> steroid based medicines </strong> in soft gelatin capsules and 
    <strong> cancer treatments.</strong> A global benchmark in the field of 
    <strong> Women’s Health </strong> and in 
    <strong> Hormone-Dependent Cancer Therapies.</strong>
  </p>

  {/* TOP HEADINGS ROW */}
  <div className="heading-row">

    <div
      className="heading-item"
      onClick={() => setExpanded(!expanded)}
    >
      <h2>
        <span className="green">Sex hormones</span> and gonadal <br />
        function regulators
      </h2>

      <FaChevronDown
        className={`arrow ${expanded ? "rotate" : ""}`}
      />
    </div>

    <div className="heading-item">
      <h2>
        <span className="green">Adrenal</span> corticosteroids
      </h2>
    </div>

  </div>

  {/* Expandable Content */}
  <div className={`accordion-content ${expanded ? "show" : ""}`}>
    <div className="grid">

      <div>
        <h4>Reproductive health:</h4>
        <p>
          hormonal anticonception (just progestogen or in combination with oestrogen).
        </p>
      </div>

      <div>
        <h4>Hormone therapy:</h4>
        <p>
          menstrual cycle regulation and dysmenorrhea treatment.
        </p>
      </div>

      <div>
        <h4>Replacement hormone therapy:</h4>
        <p>
          to ease the symptoms of menopause.
        </p>
      </div>

      <div>
        <h4>Cancer treatments:</h4>
        <p>
          for hormone-dependent tumors such as breast, endometrial, uterine or prostate cancer.
        </p>
      </div>

    </div>
  </div>

</div>

      </section>
      <section className="softgel-section">

  {/* LEFT SIDE */}
  <div className="softgel-left">
    <img src={softgelImage} alt="Soft gelatin capsules" />
    <div className="softgel-overlay"></div>

    <div className="softgel-text">
      <h1>
        Products in soft <br />
        gelatin capsules
      </h1>
    </div>
  </div>

  {/* RIGHT SIDE */}
  <div className="softgel-right">

    <p className="softgel-intro">
      <strong>Soft gelatin capsule</strong> technology allows us to develop 
      <strong> specialised products </strong> that require specific characteristics, 
      as well as highly complex medicines targeting rare diseases or diseases with 
      difficult formulation. This opens the door for us to markets with 
      <strong> high barriers to entry.</strong>
    </p>

    <div className="softgel-grid">

      <div className="softgel-item">
        <div className="divider"></div>
        <h4>Vitamin D derivatives:</h4>
        <p>
          related to activity by the thyroid gland and the metabolism of calcium, 
          with high lipid solubility
        </p>
      </div>

      <div className="softgel-item">
        <div className="divider"></div>
        <h4>Fatty acids:</h4>
        <p>
          regulation of triglycerides, cholesterol and needing a lipid-based formulation.
        </p>
      </div>

      <div className="softgel-item">
        <div className="divider"></div>
        <h4>Cancer treatments:</h4>
        <p>
          for products formulated with oily vehicles for improved bioavailability.
        </p>
      </div>

    </div>

  </div>

</section>
<section className="contact-section">

  {/* LEFT TEXT */}
  <div className="contact-left">
    <p>
      If you would like to know more about our product pipeline and partnership 
      opportunities, please contact our B2B team via the <strong>contact form</strong> below.
    </p>
  </div>

  {/* RIGHT FORM */}
  <div className="contact-right">
    <form className="contact-form">

      <div className="form-row">
        <div className="form-group">
          <label>Name*</label>
          <input type="text" required />
        </div>

        <div className="form-group">
          <label>Company*</label>
          <input type="text" required />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Email*</label>
          <input type="email" required />
        </div>

        <div className="form-group">
          <label>Confirm email*</label>
          <input type="email" required />
        </div>
      </div>

      <div className="form-group full-width">
        <label>Phone number</label>
        <input type="text" />
      </div>

      <div className="form-group full-width">
        <label>Message*</label>
        <textarea maxLength="700" required></textarea>
        <small>Max. 700 characters</small>
      </div>

      <div className="form-group full-width">
        <label>Attachments</label>
        <input type="file" />
        <small>Max. 2 Mb</small>
      </div>
        <div className="privacy-section">

  <div className="checkbox-row">
    <input type="checkbox" id="privacy" required />
    <label htmlFor="privacy">
      I accept the <span className="link">Cinfa Privacy Policy</span>.
    </label>
  </div>

  <p className="privacy-text">
    With your consent, the personal data you provide to us when completing this form will be processed by Laboratorios Cinfa S.A. as the manager of this website. This information will only be used to process your pharmacovigilance notification, as well as to contact you should we need clarification in that regard or to answer your questions. As stated in our <span className="link">Privacy Policy</span>, we guarantee the confidentiality and security of your data, which will not be shared with third parties at any time for uses other than those described above and will not be used to send you advertising. Of course, you may exercise your rights of access, correction, limitation and erasure regarding your data at any time by writing to <span className="link">lopd@cinfa.com</span>.
  </p>

</div>
      <button type="submit" className="submit-btn">
        Submit
      </button>

    </form>
  </div>

</section>
    </div>
  );
};

export default Pipeline;